export {}; // Declare this file as a module

String.prototype.getFirstCharsFromWords = function (this: string): string {
  return this
    ? this.split(' ')
        .filter((s) => !!s)
        .map((s) => s.trim().at(0))
        .join('')
    : '';
};
